// src/data/comedians/ricky-gervais.js

const base = {
  id: 'ricky-gervais',
  slug: 'ricky-gervais',
  name: 'Ricky Gervais',
  birthYear: 1961,
  image: require('@/assets/images/img_Ricky_Gervais.jpg'),
  famousWorks: [
    'The Office (UK) (2001-2003)',
    'Extras (2005-2007)',
    'After Life (2019-2022)',
    'Humanity (2018)',
    'SuperNature (2022)',
    'Golden Globe Awards host',
    'An Idiot Abroad (creator)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'British',
    shortBio: 'Creator of The Office and fearless host',
    bio: `Ricky Gervais is a British comedian, actor, writer, and director who revolutionized television comedy with "The Office" and became known for his provocative humor and willingness to mock celebrity culture. His influence on modern comedy spans multiple continents and has redefined the sitcom format.\n\nBorn in Reading, England, Gervais initially pursued a career in music and radio before finding his calling in comedy. He co-created and starred in "The Office" in 2001, which became a cultural phenomenon and spawned successful adaptations worldwide, most notably the American version.\n\nGervais has hosted the Golden Globe Awards multiple times, earning both praise and controversy for his sharp, irreverent hosting style. His stand-up specials showcase his atheistic views, animal rights activism, and willingness to tackle taboo subjects. Beyond comedy, he has created several acclaimed television series and continues to be one of the most talked-about comedians in the world.`,
    style: 'Observational, provocative, satirical, dry British wit',
    achievements: [
      'Golden Globe Awards',
      'BAFTA Awards',
      'Emmy Awards',
      'Time 100 most influential people',
      'International Emmy Founders Award',
      'Comedy Awards (UK)',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Britannique',
    shortBio: 'Créateur de The Office et animateur intrépide',
    bio: `Ricky Gervais est un comédien, acteur, écrivain et réalisateur britannique qui a révolutionné la comédie télévisée avec "The Office" et est devenu connu pour son humour provocateur et sa volonté de se moquer de la culture des célébrités. Son influence sur la comédie moderne s'étend sur plusieurs continents.\n\nNé à Reading en Angleterre, Gervais a d'abord poursuivi une carrière dans la musique et la radio avant de trouver sa vocation dans la comédie. Il a co-créé et joué dans "The Office" en 2001, qui est devenu un phénomène culturel et a engendré des adaptations réussies dans le monde entier.\n\nGervais a animé les Golden Globe Awards à plusieurs reprises, récoltant éloges et controverses pour son style d'animation tranchant et irrévérencieux. Ses specials stand-up mettent en avant ses vues athées, son militantisme pour les droits des animaux et sa volonté d'aborder des sujets tabous.`,
    style: 'Observationnel, provocateur, satirique, humour britannique pince-sans-rire',
    achievements: [
      'Golden Globe Awards',
      'BAFTA Awards',
      'Emmy Awards',
      'Time 100 personnalités les plus influentes',
      'International Emmy Founders Award',
      'Comedy Awards (Royaume-Uni)',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Británico',
    shortBio: 'Creador de The Office y presentador intrépido',
    bio: `Ricky Gervais es un comediante, actor, escritor y director británico que revolucionó la comedia televisiva con "The Office" y se hizo conocido por su humor provocador y su disposición a burlarse de la cultura de las celebridades. Su influencia en la comedia moderna abarca múltiples continentes.\n\nNacido en Reading, Inglaterra, Gervais inicialmente persiguió una carrera en música y radio antes de encontrar su vocación en la comedia. Co-creó y protagonizó "The Office" en 2001, que se convirtió en un fenómeno cultural con adaptaciones exitosas en todo el mundo.\n\nGervais ha presentado los Golden Globe Awards múltiples veces, ganándose tanto elogios como polémica por su estilo de presentación agudo e irreverente. Sus especiales de stand-up muestran sus puntos de vista ateos, su activismo por los derechos de los animales y su disposición a abordar temas tabú.`,
    style: 'Observacional, provocador, satírico, ingenio británico seco',
    achievements: [
      'Golden Globe Awards',
      'BAFTA Awards',
      'Emmy Awards',
      'Time 100 personas más influyentes',
      'International Emmy Founders Award',
      'Comedy Awards (Reino Unido)',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'بريطاني',
    shortBio: 'مبتكر The Office ومقدّم لا يهاب',
    bio: `ريكي جيرفيس كوميدي وممثل وكاتب ومخرج بريطاني أحدث ثورة في الكوميديا التلفزيونية بمسلسل "The Office" واشتُهر بفكاهته الاستفزازية واستعداده للسخرية من ثقافة المشاهير. تأثيره على الكوميديا الحديثة يمتد عبر قارات عدة.\n\nوُلد في ريدينج بإنجلترا، وسعى في البداية إلى مسيرة في الموسيقى والراديو قبل أن يجد ضالّته في الكوميديا. شارك في ابتكار وتمثيل "The Office" عام 2001 الذي أصبح ظاهرة ثقافية أُعيد إنتاجها عالميًا.\n\nقدّم جيرفيس Golden Globe Awards مرات عدة، مستجلبًا الإشادة والجدل على حدٍّ سواء بأسلوبه الحاد غير القابل للترويض. تعكس عروضه الخاصة قناعاته الإلحادية ونشاطه في حقوق الحيوان واستعداده لمعالجة الموضوعات المحظورة.`,
    style: 'ملاحظاتي، استفزازي، ساخر، ذكاء بريطاني جاف',
    achievements: [
      'جوائز Golden Globe',
      'جوائز BAFTA',
      'جوائز Emmy',
      'قائمة Time 100 للشخصيات الأكثر تأثيرًا',
      'International Emmy Founders Award',
      'جوائز الكوميديا (المملكة المتحدة)',
    ],
  },
];
